export default "__VITE_ASSET__ZdHo3Mtu__"